"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFailureBannerAction;

var _I18n = _interopRequireDefault(require("I18n"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _AppActions = require("../actions/AppActions");

var ERROR_TO_MSG = (0, _keyMirror.default)({
  WORKSPACES_LIMIT_HIT: null
});

function getFailureBannerAction(err, defaultTitle, defaultBody) {
  var errResponse = err && err.responseJSON;

  if (errResponse && errResponse.message && ERROR_TO_MSG[errResponse.message]) {
    return (0, _AppActions.showFailureBanner)(_I18n.default.t('workspacesManager.errors.sorry'), _I18n.default.t("workspacesManager.apiErrors." + errResponse.message));
  }

  return (0, _AppActions.showFailureBanner)(defaultTitle, defaultBody);
}

module.exports = exports.default;